import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  homeInsurancePercentage?: number;
  purchasePrice?: number;
  propertyValue?: number;
  purchasePriceActive?: boolean;
}

export const calculateHomeInsurance = (
  form: FormInstance,
  loanIndex: string | number,
  {
    homeInsurancePercentage,
    purchasePrice,
    propertyValue,
    purchasePriceActive
  }: FieldValues = {}
): number => {
  const homeInsurancePercentageValue = homeInsurancePercentage ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'homeInsurancePercentage'])) || 0);

  const purchasePriceValue = purchasePrice ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'purchasePrice', 'value'])) || 0);

  const propertyValueValue = propertyValue ??
    (parseFloat(form.getFieldValue(['loans', loanIndex, 'externalLoan', 'propertyValue'])) || 0);

  const purchasePriceActiveValue = purchasePriceActive ?? form.getFieldValue(['tableView', 'purchasePrice', 'active']);

  const price = purchasePriceActiveValue ? purchasePriceValue : propertyValueValue;

  if (!price) return 0;

  const homeInsurance = (price * (homeInsurancePercentageValue / 100)) / 12;

  return parseFloat(formatAmount(homeInsurance)) || 0;
};
